import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiClipboard } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail || !password) {
      addToast('Please enter email and password.', 'error');
      return;
    }
    setSubmitting(true);
    try {
      const { appUser: user } = await signIn(trimmedEmail, password);
      if (user?.role === 'admin') {
        navigate('/admin', { replace: true });
      } else if (user?.role === 'member') {
        navigate('/member', { replace: true });
      } else {
        addToast('Your account is not set up for this app. Contact admin.', 'error');
      }
    } catch (err) {
      const msg = err?.message || 'Login failed. Check email and password.';
      addToast(msg, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo" aria-hidden="true">
            <FiClipboard />
          </div>
          <h1>Web Development Task & Performance Tracker</h1>
          <p>Sign in to continue</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-form-group">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              disabled={submitting}
            />
          </div>
          <div className="login-form-group">
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              disabled={submitting}
            />
          </div>
          <button type="submit" className="login-submit-btn" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
